<template>
  <div class="container" v-if="account">
    <AssetLibrarySection :account="account" />
  </div>
</template>

<script lang="ts">
import axios from 'axios'
import { useHead } from '@unhead/vue'
import { defineComponent } from 'vue'
import AssetLibrarySection from '@components/customer_page/sections/asset_library/AssetLibrarySection.vue'

export default defineComponent({
  name: 'CustomerPageShow',
  components: { AssetLibrarySection },
  data() {
    return {
      account: null,
      customerPage: null,
    }
  },
  mounted() {
    axios.get(`/api/accounts/${this.$route.params.id}.json`).then((r) => {
      this.account = r.data.account
      useHead(() => {
        return {
          title: `${this.account.name} Customer Page | UserEvidence`,
          meta: [{ hid: 'theme-color', name: 'theme-color', content: this.account?.brand_color_1 }],
        }
      })
    })
    // ahoy.trackView()
    window.addEventListener('resize', this.sendHeightToParent)
  },
  updated() {
    this.sendHeightToParent()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.sendHeightToParent)
  },
  methods: {
    sendHeightToParent() {
      const height = document.body.scrollHeight
      window.parent.postMessage({ height: height }, '*')
    },
  },
})
</script>
